import {sortByDistance, sortByPriority} from "@global/global-elements/global-dealer-search/utilities.js";

export default {
    mapCenter(state) {
        return state.mapCenter
    },
    getZoom(state) {
        return state.zoom
    },
    dealers(state) {
        let dealers = state.dealerData.dealers || []

        // Valid dealery may need an email and must have at least one of the possible filters
        return dealers.filter(dealer => {
            if (state.requireEmail && dealer.email && dealer.email.length < 3) { // x@y is the shortest possible email
                return false
            }

            return state.dealerData.dealerTypes.some(type => {
                return dealer.dealerTypes.includes(type.identifier)
            })
        });

    },
    dealerTypes(state) {
        return state.dealerData.dealerTypes || []
    },
    userLocation(state) {
        return state.userLocation
    },
    getCity(state) {
        return state.city
    },
    getCountry(state) {
        return state.country
    },
    getRadius(state) {
        return state.radius
    },
    getDealersInCountry(state, getters) {
        if (state.country) {
            return getters.dealers.filter(dealer => dealer.country === state.country)
        }
        return getters.dealers;
    },
    getFilteredDealers(state, getters) {
        const filters = state.availableFilters
        const selectedFilters = filters.filter(filter => filter.selected);

        // Dealers have a dealerTypes property that is an array of strings
        // selectedFilters is an array of objects with a name property
        // Filter possible dealers so that the dealery dealerTypes contains all selectedFilters names
        return getters.getDealersInCountry.filter(dealer => {
            return selectedFilters.every(filter => dealer.dealerTypes.includes(filter.name))
        })
    },
    getResultDealers(state) {
        if (!state.dealerResults) {
            return null
        }

        const sortDealers = (dealers => {
            // Bei mehr als 30 Ergebnissen die 30 nähesten nach Prio ausgeben, dann erst welche die weiter weg sind auch wenn die prio häher ist
            if (dealers.length && dealers[0].distance && dealers.length > 30) {
                const dealersByDistance = sortByDistance(dealers)
                return [...sortByPriority(dealersByDistance.slice(0, 30)), ...dealers.slice(31, dealersByDistance.length)]
            }
            // Sonst immer nach Priorität sortieren (bei gleicher Prio nach Entfernung und dann nach Name)
            return sortByPriority(dealers)
        })

        return sortDealers(state.dealerResults)
    },
    getAvailableFilters(state) {
        return state.availableFilters
    }
};
